// extracted by mini-css-extract-plugin
export default {"root":"UtvP6LQ2","hidden":"xYkfrKnb","dots":"PdzBnsGR","tonInUsdDescription":"VMKBAQXy","getMoreStarsLink":"GGPosAVA"};